const translatedBoKeys = {

    'WARNING' : 'Advertência',
    'APPREHENSION' : 'Apreensão',
    'EMBARGO' : 'Embargo',
    'CLOSURE' : 'Fechamento',
    'INTERDICTION' : 'Interdição',
    'SEALING' : 'Lacração',
    'FINE' : 'Multa',
    'NOTIFICATION' : 'Notificação',
    'ORIENTATION' : 'Orientação',
    'REMOVAL' : 'Remoção',
    'PARTIAL_SUSPENSION' : 'Suspensão Parcial',
    'TOTAL_SUSPENSION' : 'Suspensão Total',

    'FEMALE' : 'FEMININO',
    'MALE' : 'MASCULINO',

    'DENIED' : 'Negou-se a assinar',
    'UNABLE' : 'Impossibilitado de assinar',
    'SIGNATURE' : 'Assinatura',

    'MARRIED' : 'CASADO(A)',
    'DIVORCED' : 'DIVORCIADO(A)',
    'SEPARATED' : 'SEPARADO(A)',
    'SINGLE' : 'SOLTEIRO(A)',
    'STABLE_UNION' : 'UNIÃO ESTÁVEL',
    'WIDOWER' : 'VIÚVO(A)',

    'ANTRHOPIZED' : 'Antropizada',
    'APP' : 'APP - Área de Preservação',
    'RURAL' : 'Rural',
    'UC' : 'UC - Unidade de Conservação',
    'URBAN' : 'Urbana',
    'DAMPING_ZONE' : 'Zona de Amortecimento',

    'MILLIGRAM' : 'Miligrama (mg)',
    'GRAM' : 'Grama (g)',
    'KILOGRAM' : 'Quilograma (Kg)',
    'MILLILITER' : 'Mililitro (mL)',
    'LITER' : 'Litro (L)',
    'CENTIMETER' : 'Centímetro (cm)',
    'METER' : 'Metro (m)',
    'PIECE' : 'Peça (pç)',
    'UNITY' : 'Unidade (un)',

    'PRISONER_DELIVERY' : 'Auto de entrega de preso',
    'EXHIBITION_AND_APPREHENSION' : 'Auto de exibição e apreensão',
    'DRUNKENNESS_TERM' : 'Termo de Constatação de Embriaguez',
    'BREATHALYZER_TEST' : 'Teste Etilômetro',
    'VEHICLE_SEIZURE_NOTICE' : 'Guia de Recolhimento de Veículo',
    'CRLV_SEIZURE_NOTICE' : 'Guia de Recolhimento de CRLV',
    'ARREST_WARRANT' : 'Mandado de prisão',
    'VEHICLE_IDENTIFICATION_IC' : 'Laudo de constatação IC',
    'ASSESSMENT' : 'Autuação',
    'BOPC' : 'BOPC',
    'BOPM' : 'BOPM',
    'MEDICAL_REPORT' : 'Laudo médico',
    'OTHERS' : 'Outros',
    'TEST_REPORT' : 'Relatório de ensaio',
    'ROF' : 'ROF',
    'TESTIMONIAL_TERM' : 'Termo de depoimento',
    'PROTECTIVE_MEASURE' : 'Medida Protetiva',
    'POLICE_REPORT' : 'Termo circunstanciado',
    'OAB' : 'OAB',
    'CREA' : 'CREA',
    'CRM' : 'CRM',
    'MEDICAL_ASSISTANCE_REPORT' : 'Boletim de Atendimento Médico (BAM)',
    'REFERRAL_CEAM' : 'Encaminhamento ao CEAM',


    'INVALIDATED' : 'Invalidado',
    'PENDING' : 'Pendente (aprovação)',
    'REJECTED' : 'Reprovado',
    'REVIEWED' : 'Revisado',
    'APPROVED' : 'Aprovado',
    'NUMBER_GENERATED' : 'Numeração gerada' ,
    'DRAFT' : 'Em preenchimento' ,
    'APP_DELETED' : 'Excluído (app)' ,
    'SYSTEM_DELETED' : 'Excluído (sistema)' ,
    'FILE_SENT' : 'Documento enviado',

    // 'APP' : 'App',
    'UPLOAD_FILE' : 'Envio de arquivo',
    'WEB' : 'Área web',

}

export default translatedBoKeys;
